
import React, { useRef, useEffect } from 'react';
import { DrawData } from './Canvas';

interface DrawingDisplayProps {
    drawingData: DrawData[];
    width: number;
    height: number;
}

export const DrawingDisplay: React.FC<DrawingDisplayProps> = ({ drawingData, width, height }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas?.getContext('2d');

        if (context && canvas) {
            // Clear canvas
            context.clearRect(0, 0, width, height);

            // Redraw based on data
            if (drawingData) {
                drawingData.forEach(data => {
                    context.globalCompositeOperation = data.color === 'eraser' ? 'destination-out' : 'source-over';
                    context.beginPath();
                    // For eraser, color doesn't matter but needs to be valid
                    context.strokeStyle = data.color === 'eraser' ? '#000' : data.color;
                    context.lineWidth = data.lineWidth;
                    context.moveTo(data.x0 * width, data.y0 * height);
                    context.lineTo(data.x1 * width, data.y1 * height);
                    context.stroke();
                    context.closePath();
                });
                // Reset composite operation after drawing everything
                context.globalCompositeOperation = 'source-over';
            }
        }
    }, [drawingData, width, height]);

    return (
        <canvas
            ref={canvasRef}
            width={width}
            height={height}
            style={{ backgroundColor: '#4a4a4a', border: '2px solid #000' }}
        />
    );
};
